module.exports = {
    apiKey: 'AIzaSyAupjVGKpS-B8W3WsTJrelg2q6RkA1qTq0',
    authDomain: 'hiq-theme-builder.firebaseapp.com',
    databaseURL: 'https://hiq-theme-builder.firebaseio.com',
    projectId: 'hiq-theme-builder',
    storageBucket: 'hiq-theme-builder.appspot.com',
    messagingSenderId: '372952227791'
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js